/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { dataError, dataLoaded, dataLoading, dataNotAsked, isDataNotAsked } from '../../utils/dataState';
import { AuthActions, AuthLogoutAction } from '../auth/types';
import {
  OrganizationActions,
  OrganizationDetailsActionTypes,
  OrganizationDetailsState,
  OrganizationsActionTypes,
  OrganizationsState,
} from './types';

export const initialOrganizationDetailsState: OrganizationDetailsState = {
  isFetching: false,
  options: undefined,
  organization: undefined,
  errorMessage: undefined,
};

export function organizationDetails(
  state = initialOrganizationDetailsState,
  action: OrganizationDetailsActionTypes,
): OrganizationDetailsState {
  switch (action.type) {
    case OrganizationActions.ORG_DETAILS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case OrganizationActions.ORG_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        organization: action.payload.organization,
        options: {
          payload: action.payload.organization,
        },
      };
    case OrganizationActions.ORG_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
}

export const initialOrganizationsState: OrganizationsState = {
  isFetching: false,
  options: [],
  dataState: dataNotAsked(),
};

// The organizations reducer
export function organizations(
  state = initialOrganizationsState,
  action: OrganizationsActionTypes | AuthLogoutAction,
): OrganizationsState {
  switch (action.type) {
    case OrganizationActions.ORGANIZATIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        dataState: isDataNotAsked(state.dataState) ? state.dataState : dataLoading(),
      };
    case OrganizationActions.ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        options: action.payload.options,
        dataState: dataLoaded(),
      };
    case OrganizationActions.ORGANIZATIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
        dataState: dataError(),
      };
    case AuthActions.AUTH_LOGOUT:
      return { ...initialOrganizationsState };
    default:
      return state;
  }
}
